<template>
  <span class="mc-liveview-setting">
    <i v-b-modal.select_options_temp class="mc-fa icon-outline_settings" />

    <b-modal
      id="select_options_temp"
      ref="select_options_temp"
      target="select_options_temp"
      size="sm"
      hide-header
      hide-footer
      scrollable
      no-close-on-backdrop
      hide-backdrop
      no-enforce-focus
      centered
      :show.sync="popoverShow"
      :modal-class="
        $store.state.sidebar.sideBarOpen
          ? 'mc-modal-options mc-modal-options--temp'
          : `mc-modal-options mc-modal-options--temp mc-panel-close ${
              swipped ? 'mc-modal-info--swipe' : null
            }`
      "
      @show="onShow"
    >
      <span class="mc-modal-info__swipe" @click="onSwipe"></span>

      <h4 class="mc-modal-info__head">
        {{ $t('trackingTemp.form.configuration') }}
        <i class="mc-fa icon-outline_close" @click="close"></i>
      </h4>

      <div class="mc-modal-info__options">
        <p class="mc-modal-info__options-title mb-1">{{ $t('trackingTemp.mapView') }}</p>
        <div class="mc-modal-info__options-item">
          <div class="mc-modal-info__options-item-wrapper">
            <b-row>
              <b-col md="6">
                <div class="mc-modal-info__options-item-custom-check">
                  <input
                    v-model="form.fleetCluster"
                    type="checkbox"
                    @change="handleChangeSetting('fleetCluster')"
                  />
                  <label>
                    <img src="@/assets/images/map/map-cluster.png" alt />
                  </label>
                  <span>{{ $t('trackingTemp.cluster') }}</span>
                </div>
              </b-col>
              <b-col md="6">
                <div class="mc-modal-info__options-item-custom-check">
                  <input
                    v-model="form.traffic"
                    type="checkbox"
                    @change="handleChangeSetting('traffic')"
                  />
                  <label>
                    <img src="@/assets/images/map/map-traffic.png" alt />
                  </label>
                  <span>{{ $t('trackingTemp.traffic') }}</span>
                </div>
              </b-col>
              <b-col md="6">
                <div class="mc-modal-info__options-item-custom-check">
                  <input
                    v-model="form.location_google"
                    type="checkbox"
                    @change="handleChangeSetting('location_google')"
                  />
                  <label>
                    <img src="@/assets/images/map/map-google.png" alt />
                  </label>
                  <span>{{ $t('trackingTemp.googleLocation') }}</span>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <p class="mc-modal-info__options-title mb-1">{{ $t('trackingTemp.mapType') }}</p>
        <div class="mc-modal-info__options-item">
          <div class="mc-modal-info__options-item-wrapper">
            <b-row>
              <b-col md="6">
                <div class="mc-modal-info__options-item-custom-check">
                  <input
                    v-model="form.mapMode"
                    type="radio"
                    name="mapview"
                    value="roadmap"
                    @change="handleChangeSetting('mapMode')"
                  />
                  <label>
                    <img src="@/assets/images/map/map-def.png" alt />
                  </label>
                  <span>Default</span>
                </div>
                <div
                  v-if="form.mapMode === 'roadmap'"
                  class="form-check form-switch mc-modal-info__options-item-custom-check-type justify-content-between"
                >
                  <label class="form-check-label">{{ $t('trackingTemp.terrain') }}</label>
                  <input
                    v-model="form.mapModeMedan"
                    class="form-check-input"
                    type="checkbox"
                    name="check-button"
                    switch
                    @change="handleChangeSetting('mapModeMedan')"
                  />
                </div>
              </b-col>
              <b-col md="6">
                <div class="mc-modal-info__options-item-custom-check">
                  <input
                    v-model="form.mapMode"
                    type="radio"
                    name="mapview"
                    value="satellite"
                    @change="handleChangeSetting('mapMode')"
                  />
                  <label>
                    <img src="@/assets/images/map/map-satelite.png" alt />
                  </label>
                  <span>{{ $t('trackingTemp.satellite') }}</span>
                </div>
                <div
                  v-if="form.mapMode === 'satellite'"
                  class="form-check form-switch mc-modal-info__options-item-custom-check-type justify-content-between"
                >
                  <label class="form-check-label">{{ $t('trackingTemp.mapLabel') }}</label>
                  <input
                    v-model="form.mapModeLabel"
                    class="form-check-input"
                    type="checkbox"
                    name="check-button"
                    switch
                    @change="handleChangeSetting('mapModeLabel')"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-modal>
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import responsive from '@/mixin/responsive'

export default {
  name: 'RBSelectOptions',
  mixins: [responsive],
  data() {
    return {
      form: {
        auto_reload: true,

        fleetCluster: true,
        traffic: true,
        location_google: true,
        mapMode: 'roadmap',
        mapModeMedan: false,
        mapModeLabel: false,
      },

      autoReload: true,
      popoverShow: false,
      swipped: false,

      fleet_group: [],
      timer: 0,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
  },
  async created() {
    this.$store.commit('fleets/loadingKendaraan', true)

    this.$nextTick(function () {
      window.setInterval(
        () => {
          if (localStorage.getItem('auto_reload') == 'true') {
            let filter = {
              filter: {
                vehicleId: this.$store.state.map.vehicleIds,
                hasConnectedDevice: true,
              },
            }

            let payload = {
              filter: filter,
              latLng: {
                lat: this.$store.state.map.infoWindow.detail.latitude,
                lng: this.$store.state.map.infoWindow.detail.longitude,
              },
              plate:
                this.$store.state.map.infoWindow.open &&
                this.$store.state.map.infoWindow.type == 'fleet'
                  ? this.$store.state.map.infoWindow.detail.licensePlate
                  : '',
            }

            this.requestFleets(payload)
          }
        },
        this.$store.state.config.mode === 'development' ? 10000 : 30000
      )

      const requestFleet = async () => {
        const filter = {
          filter: {
            vehicleId: this.$store.state.map.vehicleIds,
            hasConnectedDevice: true,
          },
        }
        await this.requestFleets({ filter: filter, plate: '' })
        this.$root.$emit('refreshFleets')
        this.$store.commit('fleets/loadingKendaraan', false)
      }

      this.timer = setTimeout(() => {
        requestFleet()
      }, 500)
    })

    await this.setOptionsFromCookie()
    window.addEventListener('focus', this.setOptionsFromCookie)

    if (localStorage.getItem('auto_reload') === null)
      localStorage.setItem('auto_reload', this.autoReload)

    this.autoReload = JSON.parse(localStorage.getItem('auto_reload'))
    this.$store.commit('fleets/autoReload', this.autoReload)
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.setOptionsFromCookie)
  },
  methods: {
    onShow() {
      this.swipped = false
      if (this.mediaQuery.matches && this.$store.state.sidebar.sideBarOpen) {
        this.$store.commit('sidebar/toggleSideBar')
      }
    },

    onSwipe() {
      this.swipped = !this.swipped
    },

    close() {
      this.$bvModal.hide('select_options_temp')
      if (this.mediaQuery.matches && this.$store.state.sidebar.sideBarOpen) {
        this.$store.commit('sidebar/toggleSideBar')
      }
      this.swipped = false
    },

    ...mapActions('fleets', ['requestFleets']),
    onClose() {
      this.popoverShow = false
    },

    async setOptionsFromCookie() {
      const cookiesMap = new Map()
      document.cookie.split('; ').forEach((cookie) => {
        const [key, value] = cookie.split('=')
        cookiesMap.set(key, value)
      })

      Object.keys(this.form).forEach((key) => {
        let value = cookiesMap.get(key)

        // set cookie
        if (value === undefined) {
          document.cookie = `${key}=${this.form[key]}`
          return
        }

        // parse the cookie to boolean value if the cookie value is a boolean in string
        if (['true', 'false'].includes(value)) {
          value = value === 'true' ? true : false
        }

        // skip changing the form if have the same value with cookies
        if (value === this.form[key]) return

        // set the form state
        this.$set(this.form, key, value)

        if (['mapMode', 'mapModeMedan', 'mapModeLabel'].includes(key)) return

        this.handleChangeSetting(key)
      })

      this.handleChangeSetting('mapMode')
      await this.$nextTick()
    },

    handleChangeSetting(key) {
      document.cookie = `${key}=${this.form[key]}`

      if (key === 'fleetCluster') {
        this.$store.commit('fleets/fleetCluster', this.form[key])
      }

      if (['mapMode', 'mapModeMedan', 'mapModeLabel'].includes(key)) {
        if (this.form.mapMode === 'roadmap') {
          this.$store.commit(
            'fleets/mapMode',
            this.form.mapModeMedan ? 'terrain' : this.form.mapMode
          )
        } else if (this.form.mapMode === 'satellite') {
          this.$store.commit(
            'fleets/mapMode',
            this.form.mapModeLabel ? 'hybrid' : this.form.mapMode
          )
        }
      }

      this.$root.$emit('SettingSelectOptions')
    },
  },
}
</script>
